import React from 'react'

const AxiosIndicatorRunTimeLoader = (props) => {
    const {inline,overlay, bomLoaderClass} = props;
    return (
        <>
            <div 
                className={`loader-wrapper ${inline ? 'loader-wrapper-inline' : ''} ${overlay ? ' loader-wrapper-fixed':''} ${bomLoaderClass ? ' p-0':''}`}>
                <div className={bomLoaderClass ? "loading-icon clearfix m-0" : "loading-icon clearfix "}>
                    <div className="ball1"/>
                    <div className="ball2"/>
                    <div className="ball3"/>
                </div>
            </div>
        </> 
    )
}

export default AxiosIndicatorRunTimeLoader